
const dummyData = [
    {
      section: "Breaking News",
      channel: "CNN",
      items: [
        {
          id: "fDObf2AeAP4",
          image: "https://img.youtube.com/vi/fDObf2AeAP4/maxresdefault.jpg",
          title: "75 million Americans ordered to stay home",
          views: "1.9M views",
          published: "3 days ago"
        },
        {
          id: "3AzIgAa0Cm8",
          image: "https://img.youtube.com/vi/3AzIgAa0Cm8/maxresdefault.jpg",
          title: "Gupta: The truth about using chloroquine to fight coronavirus pandemic",
          views: "128K views",
          published: "4 hours ago"
        },
        {
          id: "Wbk8ZrfU3EM",
          image: "https://img.youtube.com/vi/Wbk8ZrfU3EM/maxresdefault.jpg",
          title: "Tom Hanks and Rita Wilson test positive for coronavirus",
          views: "600k views",
          published: "1 week ago"
        },
      ]
    },
    {
      section: "Entertainment",
      channel: "Trend TV",
      items: [
                      {
          id: "92B37aXykYw",
          image: "https://img.youtube.com/vi/92B37aXykYw/maxresdefault.jpg",
          title: "Willie Jones STUNS Simon Cowell In Pitch Perfect Performance of 'Your Man'!",
          views: "2.47 million views",
          published: "1 month ago"
        },
        {
          id: "vVeVcVBW_CE",
          image: "https://img.youtube.com/vi/vVeVcVBW_CE/maxresdefault.jpg",
          title: "Mr. McMahon and Donald Trump's Battle of the Billionaires Contract Signing",
          views: "33 million views",
          published: "Dec 8, 2013"
        },
        
        {
          id: "bzkWFljIMVg",
          image: "https://img.youtube.com/vi/bzkWFljIMVg/maxresdefault.jpg",
          title: "Two of the MOST UNEXPECTED Champions League Wins EVER",
          views: "877k views",
          published: " Nov 10, 2019"
        }
      ]
    },
    {
      section: "  Recommended",
      channel: "CGTN America",
      items: [
        {
          id: "tRLDPy1A8pI",
          image: "https://img.youtube.com/vi/tRLDPy1A8pI/maxresdefault.jpg",
          title: "Is Trump blaming China for COVID-19? You decide.",
          views: "876k views",
          published: "9 days ago"
        },
        {
          id: "2ulH1R9hlG8",
          image: "https://img.youtube.com/vi/2ulH1R9hlG8/maxresdefault.jpg",
          title: "Journalist still goes to office during pandemic, see her daily routine",
          views: "873 views",
          published: "3 hours ago"
        },
        {
          id: "_TkfQ9MaIgU",
          image: "https://img.youtube.com/vi/_TkfQ9MaIgU/maxresdefault.jpg",
          title: "How are small businesses going to survive the economic downturn of the COVID-19 era?",
          views: "283 views",
          published: "4 day ago"
        }
      ]
    }
  ];
  
  export default dummyData;